import type { GlucoseTotalUnicornsInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { UnicornIcon } from "@tandemdiabetes/sugarmate-react-components"
import { useCalculationsContext } from "../CalculationsContext"
import styles from "./Tile.module.scss"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import { usePolyglot } from "src/contexts"

export function GlucoseTotalUnicorns(props: TileProps<GlucoseTotalUnicornsInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()
  const { glucoseCalculations } = useCalculationsContext()
  const { unicorns } = glucoseCalculations[range] || {}

  const value = isNaN(unicorns) || unicorns === undefined ? "--" : unicorns.toLocaleString(polyglot.locale())

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {value}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        <UnicornIcon className={styles.unitIcon} />
        {polyglot.t("pages.home.insights.unicorn_unit")}
      </TileUnit>
    </>
  )
}
